<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button mat-raised-button (click)="saleOpenCalled()">Open Today Sale</button>
      </div>
    </div>
  </div>
</section>
